import { type Page } from '@editor2/types/page';
import { pick } from './pick';

export const pageToPageProperties = (page: Page) => {
	const properties = pick(page, [
		'family_id',
		'page_number',
		'page_type',
		'name',
		'sub',
		'page_group',
		'splash_url',
		'splash_content',
		'notes',
		'metadata',
		'instructor_only'
	]);

	return properties;
};
